/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import converterFieldsetTemplate from './converter-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ConverterDirective($compile, $templateCache, $translate, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(converterFieldsetTemplate);
        element.html(template);
        scope.types = types;
        scope.executionTimeout = 100;

        scope.converterTypeChanged = () => {
            scope.converter.configuration = {};
            if (scope.converter.type == types.converterType.CUSTOM.value) {
                if (!scope.converter.configuration.decoder || !scope.converter.configuration.decoder.length) {
                    scope.converter.configuration.decoder = '// Do not decode anything, just put it into AS as is\n' +
                        'var arr = [];\n' +
                        'for (var i = 0; i < bytes.length; ++i) {\n' +
                        '    arr.push(bytes[i]);\n' +
                        '}\n' +
                        'return {"bytes": JSON.stringify(arr), "port": port, "payload length": bytes.length};';
                }
                if (!scope.converter.configuration.encoder || !scope.converter.configuration.encoder.length) {
                    scope.converter.configuration.encoder = '// Encode downlink messages sent in\n' +
                        '// Base64 format as an array or buffer of bytes.\n' +
                        'function atob(input) {\n' +
                        '    var chars = \'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\';\n' +
                        '    var str = String(input).replace(/[=]+$/, \'\'); // #31: ExtendScript bad parse of /=\n' +
                        '    if (str.length % 4 === 1) {\n' +
                        '        throw new InvalidCharacterError("\'atob\' failed: The string to be decoded is not correctly encoded.");\n' +
                        '    }\n' +
                        '    for (\n' +
                        '        var bc = 0, bs, buffer, idx = 0, output = \'\';\n' +
                        '        buffer = str.charAt(idx++);\n' +
                        '        ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0\n' +
                        '    ) {\n' +
                        '        buffer = chars.indexOf(buffer);\n' +
                        '    }\n' +
                        '    return output;\n' +
                        '}\n' +
                        '\n' +
                        'function base64ToArray(base64) {\n' +
                        '    var binary_string = atob(base64);\n' +
                        '    var len = binary_string.length;\n' +
                        '    var result = [];\n' +
                        '    for (var i = 0; i < len; i++) {\n' +
                        '        result.push(binary_string.charCodeAt(i));\n' +
                        '    }\n' +
                        '    return result;\n' +
                        '}\n' +
                        '\n' +
                        'if (data.params) {\n' +
                        '    var bytes = base64ToArray(data.params.data);\n' +
                        '    return {"port": data.params.port, "bytes": bytes};\n' +
                        '}\n' +
                        '\n' +
                        'return {"port": 0, "bytes": [0x00]};';
                }
            } else if (scope.converter.type == types.converterType.CUSTOM_V2.value) {
                if (!scope.converter.configuration.decoder || !scope.converter.configuration.decoder.length) {
                    scope.converter.configuration.decoder = 
                        '    // input object structure:\n' +
                        '    // - bytes - int[]\n' +
                        '    // - fPort - int\n' +
                        '    // - recvTime - Date (needs type check)\n' +
                        '    // - tektelicMetadata - Object\n' +
                        '\n' +
                        /*
                            Checking if recvTime is Date is needed because during updating converter on UI
                            the converter fuтction is tested using validation-args passed in converter-fieldset.tpl.html
                            I could not pass recvTime: new Date(), so I had to do recvTime: {}
                            During ULs processing, the actual Date object will be passed and it would work fine.
                            But in order to pass converter validation on UI, we need to have this type check.
                         */
                        '    if (input.recvTime instanceof Date) {\n' +
                        '        // date operations\n' +
                        '    }\n' +
                        '\n' +
                        '    // output object structure:\n' +
                        '    // - data - Object\n' +
                        '    // - errors - string[]\n' +
                        '    // - warnings - string[]\n' +
                        '    // - tektelicMetadata - Object\n' +
                        '    return {\n' +
                        '        "data": {},\n' +
                        '        "errors": [],\n' +
                        '        "warnings": [],\n' +
                        '        "tektelicMetadata": input.tektelicMetadata\n' +
                        '    };';
                }
                if (!scope.converter.configuration.encoder || !scope.converter.configuration.encoder.length) {
                    scope.converter.configuration.encoder = 
                        '    // input object structure:\n' +
                        '    // - data - Object (customer-defined)\n' +
                        '\n' +
                        '\n' +
                        '    // output object structure:\n' +
                        '    // - fPort - int\n' +
                        '    // - bytes - int[]\n' +
                        '    // - errors - string[]\n' +
                        '    // - warnings - string[]\n' +
                        '    return {\n' +
                        '        "fPort": 0,\n' +
                        '        "bytes": [],\n' +
                        '        "errors": [],\n' +
                        '        "warnings": []\n' +
                        '    };';
                }
            }
        }

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            converter: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/converter/converter.directive.js